const HYPERVERGE_SDK_URL = "https://hv-web-sdk-cdn.hyperverge.co/hyperverge-web-sdk@11.4.1/src/sdk.min.js";

let sdkPromise = null;

export function loadHyperVergeSDK() {
  if (sdkPromise) {
    return sdkPromise;
  }

  sdkPromise = new Promise((resolve, reject) => {
    // SDK is already loaded
    if (window.HyperKYCModule && window.HyperKycConfig) {
      resolve();
      return;
    }

    const script = document.createElement("script");

    script.src = HYPERVERGE_SDK_URL;
    script.async = true;

    script.onload = () => {
      if (window.HyperKYCModule && window.HyperKycConfig) {
        resolve();
      } else {
        reject(new Error("HyperVerge SDK loaded but required objects are not available"));
      }
    };

    script.onerror = () => {
      reject(new Error("Failed to load HyperVerge SDK"));
    };

    document.head.appendChild(script);
  });

  return sdkPromise;
}
